import type { ReactElement } from 'react'
import {
  AddCircle24Regular,
  CalendarLtr24Regular,
  Chat24Regular,
  ChartMultiple24Regular,
  Document24Regular,
  Home24Regular,
  MegaphoneLoud24Regular,
  People24Regular,
  Person24Regular,
  Shield24Regular,
  Sparkle24Regular,
  Trophy24Regular,
} from '@fluentui/react-icons'

export interface NavItem {
  to: string
  label: string
  icon: ReactElement
  end?: boolean
  adminOnly?: boolean
}

export interface NavSection {
  title?: string
  adminOnly?: boolean
  items: NavItem[]
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ to: '/', label: '首页', icon: <Home24Regular />, end: true }],
  },
  {
    title: '参赛者',
    items: [
      { to: '/events', label: '赛事广场', icon: <Trophy24Regular /> },
      { to: '/teams', label: '战队广场', icon: <People24Regular /> },
      { to: '/leaderboard', label: '排行榜', icon: <ChartMultiple24Regular /> },
      { to: '/articles', label: '赛事资讯', icon: <Document24Regular /> },
      { to: '/recruitments', label: '赛事招募', icon: <MegaphoneLoud24Regular /> },
      { to: '/predictions', label: '竞猜预测', icon: <Sparkle24Regular /> },
    ],
  },
  {
    title: '我的',
    items: [
      { to: '/my/events', label: '我的赛事', icon: <CalendarLtr24Regular /> },
      { to: '/events/create', label: '创建赛事', icon: <AddCircle24Regular /> },
      { to: '/profile', label: '个人中心', icon: <Person24Regular /> },
      { to: '/messages', label: '消息中心', icon: <Chat24Regular /> },
    ],
  },
  {
    title: '管理',
    adminOnly: true,
    items: [{ to: '/admin', label: '管理后台', icon: <Shield24Regular /> }],
  },
]
